import { useMemo } from 'react'
import { useTokenPriceWithUseAPI } from '~/hooks/useTokenPrice'
import { useSpotSwapPair } from '~/state/dex/hooks'
import TokenInputRow from '../TokenInputRow'
import { TradeDirection, RateState } from '../../types'
import { ArrowButton } from './styled'
import IconSwapArrow from '~/assets/images/swap-arrow.svg'
import { OnSelectTokenFunc } from '../TokenInputRow/types'

interface Props {
  rateState: RateState
  isAmountOutOfRange: boolean
  handleInputFocus: (direction: TradeDirection) => void
  handleInputChange: (direction: TradeDirection, amount: string) => void
  onSelectToken: OnSelectTokenFunc
  onDirectionChange: () => void
}

const TokensChangeArea: React.FC<Props> = ({
  rateState,
  isAmountOutOfRange,
  handleInputFocus,
  handleInputChange,
  onSelectToken,
  onDirectionChange,
}) => {
  const [inputToken, outputToken] = useSpotSwapPair()

  const orderRefreshing = useMemo(() => {
    return (
      [RateState.LOADING, RateState.REFRESH_LOADING].includes(rateState) &&
      !isAmountOutOfRange
    )
  }, [rateState, isAmountOutOfRange])

  const inputTokenPrice = useTokenPriceWithUseAPI({
    tokenAddress: inputToken?.address,
  })
  const outputTokenPrice = useTokenPriceWithUseAPI({
    tokenAddress: outputToken?.address,
    chainId: outputToken?.chainId,
  })
  const hasTokenPrice = useMemo(() => {
    return Number(inputTokenPrice) > 0 && Number(outputTokenPrice) > 0
  }, [inputTokenPrice, outputTokenPrice])

  return (
    <>
      <TokenInputRow
        direction={TradeDirection.Input}
        handleInputFocus={handleInputFocus}
        handleInputChange={handleInputChange}
        onSelectToken={onSelectToken}
        rateState={rateState}
        hasTokenPrice={hasTokenPrice}
      />
      <ArrowButton onClick={onDirectionChange}>
        <img src={IconSwapArrow} />
      </ArrowButton>
      <TokenInputRow
        direction={TradeDirection.Output}
        handleInputFocus={handleInputFocus}
        handleInputChange={handleInputChange}
        onSelectToken={onSelectToken}
        rateState={rateState}
        style={{ marginBottom: '16px' }}
        hasTokenPrice={hasTokenPrice}
        orderRefreshing={orderRefreshing}
      />
    </>
  )
}

export default TokensChangeArea
